import { combineEpics } from 'redux-observable';
import demo from './demo';
import refetch from './refetch';
import modal from './modal';

export const demoEpic = combineEpics(demo, refetch, modal);
